function likePost(post_id, should_unlike){

    // Set defaults
    let data = {
        'action': 'like_post',
        'post_id': post_id,
        'should_unlike': should_unlike
    };

    return new Promise(function(fullfill, reject){
        jQuery.ajax({
            method: 'POST',
            url: window.main_theme_objects.ajax_url,
            data: data,
        }).success((data) => {
            fullfill(data);
        }).error((data) => {
            reject(data);
        })
    });
}

//Example
//likePost(dostuff,1)
export {likePost}